import React, {Component} from 'react';
import Tab from '@material/react-tab';
import TabBar from '@material/react-tab-bar';
import '@material/react-tab-bar/dist/tab-bar.css';
import '@material/react-tab-scroller/dist/tab-scroller.css';
import '@material/react-tab/dist/tab.css';
import '@material/react-tab-indicator/dist/tab-indicator.css';


class CustomTabBar extends Component {

  render() {
    const {handleActiveIndexUpdate, activeTab} = this.props
    return (
      <div>
        <TabBar
          activeIndex={activeTab}
          className="tabs-container"
          handleActiveIndexUpdate={handleActiveIndexUpdate}
        >
          <Tab className="tabs">
            <span className='tabs-label'>Notificaciones</span>
          </Tab>
          <Tab className="tabs">
            <span className='tabs-label'>Salas</span>
          </Tab>
          <Tab className="tabs">
            <span className='tabs-label'>Parqueos</span>
          </Tab>
          <Tab className="tabs">
            <span className='tabs-label'>Eventos</span>
          </Tab>
        </TabBar>
      </div>
    )
  }
}

export default CustomTabBar
